export class Material {
    constructor(
        public id: number,
        public name: string,
        public src: string) { }
}
